import { UserSettingInstruction } from "@/components/user-settings/user-setting-instruction";

export default function SettingsInstructionPage() {
  return (
    <>
      <UserSettingInstruction />
    </>
  );
}
